import { render, staticRenderFns } from "./CommunicationTypeAdd.vue?vue&type=template&id=95414a30&"
import script from "./CommunicationTypeAdd.vue?vue&type=script&lang=js&"
export * from "./CommunicationTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports